import RestService from '../services/rest';

async function getFavorites(clientId, productId, code) {
  const clientCode = code && code !== '0' ? `&code=${code}` : '';
  return RestService.getAuthenticated(`favorites?client=${clientId}&product=${productId}${clientCode}`);
}

async function addFavorites(clientId, productId, productCode, productClientCode, quantity) {
  return RestService.postAuthenticated(`favorites/add?client=${clientId}`, {
    productId,
    productCode,
    productClientCode,
    quantity,
  });
}
async function deleteFavorites(productFavoriteId, clientId) {
  return RestService.putAuthenticated(`favorites/delete?client=${clientId}`, { productFavoriteId });
}

async function updateFavorite(favoriteId, quantity) {
  return RestService.putAuthenticated('favorites/update', { favoriteId, quantity });
}

export default {
  getFavorites,
  addFavorites,
  deleteFavorites,
  updateFavorite,
};
